import React, {useEffect, useState} from "react";

import {ResponsiveStepper, StepperContext, useStepperContext} from "../../../../components/ResponsiveStepper";

import StepGmailConsents from "./StepGmailConsents";
import EmailProvidersRadioList from "../EmailProvidersRadioList";
import StepGmailSummary from "./StepGmailSummary";
import {useFeedbackTools} from "../../../../components/FeedbackTools";
import StepDefaultSummary from "./StepDefaultSummary";
import StepSmtp, {useSmtpFormik} from "./StepSmtp";
import StepSmtpSummary from "./StepSmtpSummary";


const FormUpdate = (props) => {
    return <StepperContext>
        <FormUpdateInner {...props}/>
    </StepperContext>
}

const FormUpdateInner = (props) => {
    const {
        onClose,
        onSave,
        googleAccount,
        createGoogleAccount,
        emailFrom,
        smtpOptions,
        requestAutoReplyEnabled,
        initialProvider = "default",
        initialStep = 0
    } = props;

    const {setActiveStep, activeStep, next} = useStepperContext();
    const {showErrorNotification} = useFeedbackTools();
    const [provider, setProvider] = useState(initialProvider);
    const [disableNext, setDisableNext] = useState(false);
    const [isSaving, setIsSaving] = useState(false);

    const smtpFormik = useSmtpFormik(emailFrom, smtpOptions, async () => next());

    const stepsLabels = [
        "Seleziona servizio",
        ...(provider === "gmail" ? ["Consenso"] : []),
        ...(provider === "smtp" ? ["Impostazioni"] : []),
        "Riepilogo"
    ]

    // Set the active step on mount
    useEffect(
        () => {
            if (initialStep > 0) {
                setActiveStep(initialStep);
            }
        },
        []  // eslint-disable-line react-hooks/exhaustive-deps
    )

    const steps = [
        <EmailProvidersRadioList key="stepEmailProvider"
                                 value={provider}
                                 onChange={setProvider}/>,
        // Default
        ...(provider === "default" ? [
            <StepDefaultSummary key="defaultSummary" requestAutoReplyEnabled={requestAutoReplyEnabled}/>
        ] : []),

        // Gmail steps
        ...(provider === "gmail" ? [
            <StepGmailConsents key="gmailConsents"
                               setDisableNext={setDisableNext}
                               googleAccount={googleAccount}
                               createGoogleAccount={createGoogleAccount}/>,
            <StepGmailSummary key="gmailSummary"
                              googleAccount={googleAccount}
                              emailFrom={emailFrom}/>
        ] : []),
        // SMTP steps
        ...(provider === "smtp" ? [
            <StepSmtp key="smtp"
                      emailFrom={emailFrom}
                      formik={smtpFormik}/>,
            <StepSmtpSummary key="smtpSummary" emailFrom={emailFrom}/>
        ] : []),
    ];

    const handleSave = async () => {
        setIsSaving(true);
        try{
            await onSave(provider);
            setIsSaving(false);
            onClose();
        } catch(e) {
            showErrorNotification(e);
            setIsSaving(false);
        }
    }

    const handleNext = (e) => {
        if(activeStep === 1 && provider === "smtp" ){
            smtpFormik.handleSubmit(e);
        }else{
            next();
        }
    }

    return <ResponsiveStepper title="Seleziona servizio email"
                              isOpen={true}
                              isSaving={isSaving}
                              onClose={onClose}
                              onNext={handleNext}
                              onFinish={handleSave}
                              stepLabels={stepsLabels}
                              disableNext={disableNext || smtpOptions.isUpdating}>
        {steps}
    </ResponsiveStepper>
}

export default FormUpdate;